import { z } from 'zod';
import { optionalUuidArray } from '../zod-helpers/index.js';
/** The register's id filters; an empty list means no filter, same as the inventory list's. */
export const countVarianceFilterSchema = z.object({
    locationGroupIds: optionalUuidArray('Invalid warehouse selection.').nullish(),
    brandIds: optionalUuidArray('Invalid brand selection.').nullish(),
});
//# sourceMappingURL=count-variance-filter.js.map